import { render, staticRenderFns } from "./AddMultipleStudentIntakeWise.vue?vue&type=template&id=b31a2866"
import script from "./AddMultipleStudentIntakeWise.vue?vue&type=script&lang=js"
export * from "./AddMultipleStudentIntakeWise.vue?vue&type=script&lang=js"
import style0 from "./AddMultipleStudentIntakeWise.vue?vue&type=style&index=0&id=b31a2866&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports